var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view-404"},[_c('div',{staticClass:"wrap"},[_c('h2',[_vm._v(_vm._s(_vm.pageTitle))]),_c('p',[_vm._v("ご指定のページは見つかりません")])])])}
var staticRenderFns = []

export { render, staticRenderFns }